'use strict';

import * as util from '../util/Common.js';

const privateMap = util.createPrivateMapper();

export class EventManager {
  constructor(){
    const pv = privateMap(this);
    pv.handlers = {};
  }
  addEventListener(eventName, handler) {
    const pv = privateMap(this);
    const handlers = pv.handlers;
    if (!handlers || !eventName || typeof(handler) != 'function') {
      return;
    }
    let list = handlers[eventName];
    if (!list) {
      list = [];
      handlers[eventName] = list;
    }
    list.push(handler);
  };
  removeEventListener(eventName, handler) {
    const pv = privateMap(this);
    const handlers = pv.handlers;
    if (!handlers || !eventName || typeof(handler) != 'function') {
      return;
    }
    const list = handlers[eventName];
    if (!list) {
      return;
    }
    const l = list.length;
    for (let i = 0; i < l; i++) {
      if (list[i] == handler) {
        for (let j = i + 1; j < l; j++) {
          list[j - 1] = list[j];
        }
        list.pop();
        return;
      }
    }
  }
  removeAllListeners(){
    const pv = privateMap(this);
    pv.handlers = {};
  }
  dispatchEvent(eventName) {
    const pv = privateMap(this);
    const handlers = pv.handlers;
    if (!eventName || !handlers) {
      return;
    }
    let l;
    l = arguments.length;
    const args = [];
    for (let i = 1; i < l; i++) {
      args.push(arguments[i]);
    }
    const list = handlers[eventName];
    if (list) {
      const l = list.length;
      for (let i = 0; i < l; i++) {
        list[i].apply(this, args);
      }
    }
  };
};
